export default __webpack_public_path__ + "static/media/antri.0f9cbc13.png";